import React, { useEffect, useState } from "react";
import { Autocomplete, TextField } from '@mui/material';
import { useRecoilCallback, useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";
import InputLabelCustom from '../../../shared/components/forms/InputLabelCustom';
import AutocompleteSkeleton from '../../../shared/components/skeletons/AutocompleteSkeleton';
import { capitalizeWords, finderServicioByName } from '../../../shared/global/helpers';
import { daysAvailableState, filterSearchSelectedState, isChangeFormSearchState } from '../../state/atoms';
import { dayDefaultAvailableState } from '../calendars/state/atoms';
import { serviciosState } from './state/atoms';

import { procedimientoByServiceState, procedimientosState, specialitiesByServiceState, specialitiesState , professionalsByServiceState, professionalsState } from './state/atoms';


const AutocompleteServicio = ({ size = "small", styles }) => {

    const { catchErrorApi } = useCatchErrorApi();
    const [loading, setLoading] = useState(false);
    const setIsChangeFormSearch = useSetRecoilState(isChangeFormSearchState);
    const servicios = useRecoilValue(serviciosState);
    //const [specialities, setSpecialities] = useRecoilState(specialitiesState);
    //const [professionals, setProfessionals] = useRecoilState(professionalsState);
    const [procedimientos, setProcedimientos] = useRecoilState(procedimientosState);
    const [filterSearchSelected, setFilterSearchSelected] = useRecoilState(filterSearchSelectedState);
    const resetDayDefaultAvailable = useResetRecoilState(dayDefaultAvailableState);
    const resetDaysAvailable = useResetRecoilState(daysAvailableState);

    const loadSpeciality = useRecoilCallback(({ snapshot }) => async () => {
        const release = snapshot.retain();
        setLoading(true)
        try {

            let servicioCode = filterSearchSelected.servicioSelected.code;
            console.log("SERVICIO CODE1 => ", servicioCode );
            if(servicioCode  != null){
                const procedimientosFetch = await snapshot.getPromise(procedimientoByServiceState(servicioCode));
                // console.log("SUCURSAL CODE2 => ", sucursalCode );
                // let obj = {
                //     codSpeciality: "0",
                //     sucursalCode: sucursalCode
                //   };
                // const professionalsFetch = snapshot.getPromise(professionalsByServiceState(obj));
                const responses = await Promise.all([
                    procedimientosFetch
                ]);
                console.log("PROCEDIMIENTOS => ", responses[0]);
                setProcedimientos(responses[0])
                //setProfessionals(responses[1])

            }


        } catch (error) {
            catchErrorApi(error);
        } finally {
            setLoading(false)
            release()
        }
    }, [filterSearchSelected.servicioSelected.value]);

    useEffect(() => {
        loadSpeciality()

        // return () => {
        //     loadSpeciality();
        // }
    }, [loadSpeciality])

    return (
        <>
            <InputLabelCustom htmlFor="autocomplete-servicio" text="Servicio" style={{ ...styles.label }} />
            <Autocomplete
                style={{ ...styles.autocomplete }}
                size={size}
                id="autocomplete-servicio"
                options={servicios &&  servicios.map((option) => `${option.aseDescrip}`)}
                //options={sucursales.map((option) => `${option.serNombre}`)}
                getOptionLabel={option => capitalizeWords(option) || null}
                value={filterSearchSelected.servicioSelected.value || null}
                noOptionsText="Sin resultados"
                onChange={(event, value, reason) => {
                    setIsChangeFormSearch(true);
                    resetDayDefaultAvailable();
                    resetDaysAvailable();
                    if (reason === 'clear') {
                        setFilterSearchSelected({
                            ...filterSearchSelected,
                            sucursalSelected: {
                                ...filterSearchSelected.sucursalSelected,
                                value: '',
                                code: null
                            },                            
                            specialitySelected: {
                                ...filterSearchSelected.specialitySelected,
                                value: '',
                                code: null
                            },
                            professionalSelected: {
                                ...filterSearchSelected.professionalSelected,
                                value: '',
                                code: null
                            },
                            procedimientoSelected: {
                                ...filterSearchSelected.procedimientoSelected,
                                value: '',
                                code: null
                            },
                            servicioSelected: {
                                ...filterSearchSelected.servicioSelected,
                                value: '',
                                code: null
                            }
                        })

                        return;
                    }

                    if (reason === 'selectOption') {
                        const findServicio = finderServicioByName(servicios, value);
                        setFilterSearchSelected({
                            ...filterSearchSelected,
                            servicioSelected: {
                                ...filterSearchSelected.servicioSelected,
                                value: value,
                                code: findServicio?.aseCorrel
                            },
                            specialitySelected: {
                                ...filterSearchSelected.specialitySelected,
                                value: '',
                                code: null
                            },
                            professionalSelected: {
                                ...filterSearchSelected.professionalSelected,
                                value: '',
                                code: null
                            },
                            procedimientoSelected: {
                                ...filterSearchSelected.procedimientoSelected,
                                value: '',
                                code: null
                            }
                        })
                    }
                }}
                renderInput={(params) => <TextField {...params} placeholder="Buscar" variant="outlined" />}
            />
        </>
    )
}

export default AutocompleteServicio